import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-dashboard',
  templateUrl: './data-dashboard.component.html',
  styleUrls: ['./data-dashboard.component.scss']
})
export class DataDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
